import { render, staticRenderFns } from "./SwipeUp.vue?vue&type=template&id=340c6b4e&scoped=true"
import script from "./SwipeUp.vue?vue&type=script&lang=js"
export * from "./SwipeUp.vue?vue&type=script&lang=js"
import style0 from "./SwipeUp.vue?vue&type=style&index=0&id=340c6b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340c6b4e",
  null
  
)

export default component.exports